export const maintenancePeriods: { start: string; end: string }[] = [
    { start: '2025-02-25T07:00:00.000Z', end: '2025-02-25T09:00:00.000Z' },
    { start: '2025-02-25T09:00:00.000Z', end: '2025-02-25T14:00:00.000Z' }
];
